import { EgretLoadable } from "egret";
import { authRoles } from "../../auth/authRoles";

const ProfileForm = EgretLoadable({
  loader: () => import("./EditProfile")
});

const Settings = EgretLoadable({
  loader: () => import("./Settings")
});

const UserHelp = EgretLoadable({
  loader: () => import("../doc/MerchantHelp")
});

const merchantRoutes = [
  {
    path: "/merchant/profile",
    component: ProfileForm,
    auth: authRoles.merchant
  },
  {
  path: "/merchant/settings",
    component: Settings,
    auth: authRoles.merchant
  },
  {
    path: "/merchant/merchant-help",
    component: UserHelp,
    auth: authRoles.merchant
  }
];

export default merchantRoutes;
